import { render, staticRenderFns } from "./EntityNestedReationshipDataTable.vue?vue&type=template&id=21bc5846&scoped=true"
import script from "./EntityNestedReationshipDataTable.vue?vue&type=script&lang=js"
export * from "./EntityNestedReationshipDataTable.vue?vue&type=script&lang=js"
import style0 from "./EntityNestedReationshipDataTable.vue?vue&type=style&index=0&id=21bc5846&prod&lang=scss&scoped=true"
import style1 from "./EntityNestedReationshipDataTable.vue?vue&type=style&index=1&id=21bc5846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc5846",
  null
  
)

export default component.exports